export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-disconnected-dark.8706103b4c3429ffa5a7e3ae883d6cd0.png";